module.exports = "/images/dotloop_v3.svg?005c66cc5bba051382df0d8718f262f2";